<template>
<div class="banner3 w-100 pb3 center bg-ps-blue white postcard" :style="{'height': mobile ? '85vh' : '85vh'}">
    <div class="f1-ns f2 b tc pt5">Contact us today, get your supplies tomorrow!</div>
    <div class="w-100" :class="[mobile ? '' : 'dt']" :style="{'height': mobile ? '35vh' : '65vh'}">
      <div class="w-70-ns w-100 tl" :class="[mobile ? 'mt5' : 'dtc v-mid']">
        <div class="dt center w-60-ns" :style="{ 'height': mobile ? '' : '420px'}"> 
            <div class="dtc v-mid center f4-ns f4 pt2 pb4">
                <!-- <div class="b f2 pb4">ProSource Supply</div> -->
                <div class="w-70-ns w-100 tl mb3"><img :src="require(`@/assets/${info.logoWhite}`)" /></div>
                <div class="pa2 br2">
                  <div class="pa1 f3-ns f4 mv1"><a class="link ph2 br2" :href="info.tel"><i class="ph2 fa blue fa-phone mh2-ns mr2" style="font-size:24px"/>{{info.phone}}</a></div>
                  <div class="pa1 f3-ns f4 mv1"><a class="link ph2-ns ph1 br2" :href="info.mail"><i class="ph2 fa green fa-envelope-o mh2-ns" style="font-size:24px"/> {{info.email}}</a></div>
                  <div class="pa1 f3-ns f4 mv1"><a class="link ph2 br2" :href="info.directions" target="_blank"><i class="ph2 red fa fa-map-marker mh2-ns mr2" style="font-size:24px"/> {{info.address}}</a></div>
                </div>
            </div>
        </div>
    </div>
    <div class="w-30-ns w-100 dib" :class="[ mobile ? '' : 'dtc v-mid']">
          <div class="dt fl" :style="{ 'height': mobile ? '' : '420px'}"> 
              <div class="dtc v-mid">
                <div class="tl f3-ns f4 pa3">
                    <router-link to="/contact" class="">
                      <div class="contact-button ps-blue b br3 bg-yellow tc pa3 link">Contact Us!</div>
                  </router-link> 
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import Form from '@/components/Form2'
export default {
  name: 'ContactUs',
  props: ['info', 'mobile'],
  components: { Form }
};
</script>

<style scoped>
.postcard a {
  background-color: #fff;
  background: rgb(15, 55, 111) !important;
  color: white;
  text-decoration: none;
  transition: .3s ease;
}

.postcard a.link:hover, .link:hover {
  font-weight: bold;
  transition: .3s ease;
  color: gold;
  /* color: rgb(15,55,111); */
  background: rgb(15, 55, 111) !important;
  box-shadow: gold 3px 3px !important;
}
.link {
  box-shadow: rgb(15,55,111) 3px 3px !important;
}

.container {
  max-width: 475px;
}

.wrap-input100 {
  border-bottom: 1px solid white !important;
}

.postcard {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5)), url("../../assets/bg-contact.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
} 

.contact-button {
  color: rgb(15,55,111) !important;
}

.contact-button:hover {
  background: rgb(15, 55, 111) !important;
  color: gold !important;
  box-shadow: gold 5px 5px !important;
  transition: .3s ease;
}

.contact-button {
  box-shadow: rgb(15,55,111) 5px 5px !important;
  background:gold 5px 5px !important;
  padding: 1rem !important;
  color: rgb(15, 55, 111) !important;
  transition: .3s ease;
}
</style>